const fallbackCopyTextToClipboard = text => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    // const result = document.execCommand('copy');
    // console.log(`Fallback: Copying result: ${result}`);
  } catch (err) {
    // console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
};

export const copyTextToClipboard = text => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  return navigator.clipboard.writeText(text).then(
    () => {
      return true;
    },
    err => {
      // console.error('Async: Could not copy text: ', err);
      return false;
    }
  );
};

export const readTextFromClipboard = () => {
  const promise: Promise<string> = new Promise<string>((resolve, reject) => {
    if (!navigator.clipboard) {
      // Use the old way
      // TODO implemetn alternate way
      return;
    }

    navigator.clipboard
      .readText()
      .then(resolve)
      .catch(err => {
        reject(err);
      });
  });

  return promise;
};
